global.authToken = '___PLACEHOLDER___';
const ui = require('./classes/ui.js');
const app = require('./classes/app.js');

window.ui = ui;
window.app = app;

document.addEventListener("DOMContentLoaded", ()=>{

    ui.documentReady();
    //ui.loading.circle.show(document.body);
   
    
});
 